import axios from "axios";
import { BASE_URL_NODE } from "../../config";

export const validateTeacherApi = async (params) => {
  const newParams = params?.queryKey[1]
  return await axios.get(
    `${BASE_URL_NODE}/validate_teacher/${newParams?.email}/${newParams?.country}`
  );
};
